// extracted by mini-css-extract-plugin
module.exports = {"item":"release_type_dialog_item__1kbCb","form":"release_type_dialog_form__3kHys","subTitle":"release_type_dialog_subTitle__ZW0FK"};